export default process?.env?.VUE_APP_CLOUD_FUNCTIONS_URL || ''
